import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { CARDS_STATUSES } from '../med-review-board-body/med-review-board-body.component';
import { MedReviewService } from '../../services/med-review.service';
import { MatDialog } from '@angular/material/dialog';
import { SelectErrorDialogComponent } from '../select-error-dialog/select-error-dialog.component';
import { LayoutUtilsService } from '../../../../../core/_base/crud';
import * as moment from 'moment';
import { MedicationHistoryComponent } from '../medication-history/medication-history.component';
import { BehaviorSubject } from 'rxjs';
import { CustomDrpComponent } from '../../drp/custom-drp/custom-drp.component';
import { PatientsService } from '../../../../../core/lists';
import { ActivatedRoute } from '@angular/router';
import { PrescriptionNoteComponent } from '../../../apps/lists/patients/_subs/prescription-note/prescription-note.component';
import { NgxPermissionsService } from 'ngx-permissions';
import { PrescriptionNoteService } from '../../../apps/lists/patients/_subs/prescription-note/prescription-note.service';
import { AuthService, User } from 'src/app/core/auth';

@Component({
  selector: 'kt-med-review-card',
  templateUrl: './med-review-card.component.html',
  styleUrls: ['./med-review-card.component.scss'],
})
export class MedReviewCardComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('data') card;
  @Input() statusKey;
  @Input() patient_id;
  @Input() med_review_id;
  @Input() moveToDiscontinued;
  @Input() isPv = false;
  @Input() verifyMedication;
  @Input() markErrorFn;
  @Input() fromPatient;
  isViewMode = false;
  private statusesKeys = ['started', 'changed', 'renewed', 'notPrescribedOrDiscontinued'];
  medicationVerified = false;
  medicationError = false;
  private isSingleClick = false;
  isMouseHoverRx = new BehaviorSubject(false);
  canAddPrescriptionNote: any;
  canEditPrescriptionNote: any;
  currentUser: User;

  constructor(
    private medReviewService: MedReviewService,
    public dialog: MatDialog,
    private patientsService: PatientsService,
    public layoutUtilsService: LayoutUtilsService,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private permissionsService: NgxPermissionsService,
    private prescriptionNoteService: PrescriptionNoteService,
    private auth: AuthService,
  ) {}

  ngOnInit(): void {
    this.auth.getUserByToken().subscribe((user) => {
      this.currentUser = user;
    });
    this.canAddPrescriptionNote = this.permissionsService.getPermission('canAddPrescriptionNote');
    this.canEditPrescriptionNote = this.permissionsService.getPermission('canEditPrescriptionNote');
    if (this.isPv && !this.medicationError) {
      if (
        this.card &&
        this.card.is_verify === '0' &&
        this.card.medication_errors &&
        this.card.medication_errors.length > 0
      ) {
        this.medicationError = true;
      } else {
        this.card.medication_errors = [];
      }
    }
    if (this.activatedRoute.url[`_value`][1]?.path === 'view') {
      this.isViewMode = true;
    }
  }

  getDrugDetails(treatment: any) {
    if (treatment && treatment.prescription && treatment.prescription.drug) {
      const prescription = treatment.prescription;
      return `<div>${treatment.drug} <b>${prescription.drug.strength}
                    ${prescription.drug.unit}</b> ${treatment.drug_form}</div>`;
    }
    return '';
  }

  getHoa(treatment: any, tooltip = false, isPv = this.isPv) {
    const separator = isPv ? '<br/>' : '';
    let hoa = [0, 0, 0, 0];
    if (treatment) {
      if (treatment.hoa && typeof treatment.hoa === 'string') {
        hoa = treatment.hoa.split(',');
      } else if (treatment.hoa && treatment.hoa.length) {
        hoa = treatment.hoa;
      }
    }
    const res = `<div>m: ${hoa[0] > 0 ? '<b>' : ''}${hoa[0]}${
      hoa[0] > 0 ? '</b>' : ''
    } ${separator}  n: ${hoa[1] > 0 ? '<b>' : ''}${hoa[1]}${
      hoa[1] > 0 ? '</b>' : ''
    }  ${separator} e: ${hoa[2] > 0 ? '<b>' : ''}${hoa[2]}${
      hoa[2] > 0 ? '</b>' : ''
    } ${separator}  b: ${hoa[3] > 0 ? '<b>' : ''}${hoa[3]}${hoa[3] > 0 ? '</b>' : ''}</div>`;
    if (tooltip) {
      return res
        .replace(new RegExp('<div>', 'g'), '')
        .replace(new RegExp('<b>', 'g'), '')
        .replace(new RegExp('</b>', 'g'), '')
        .replace(new RegExp('</div>', 'g'), '');
    }
    return res;
  }

  getCardClass(statusKey: string) {
    switch (statusKey) {
      case CARDS_STATUSES.CHANGED:
      case this.statusesKeys[1]:
      case '2':
        return 'bg-blue';
      case CARDS_STATUSES.STARTED:
      case this.statusesKeys[0]:
      case '1':
        return 'bg-green';
      case CARDS_STATUSES.RENEWED:
      case '0':
      case this.statusesKeys[2]:
        return 'bg-orange';
      case CARDS_STATUSES.NOT_PRESCRIBER_OR_DISCONTINUED:
      case '3':
      case this.statusesKeys[3]:
        return 'bg-grey';
    }
  }

  getBadges(card: any) {
    let res = '';
    if (card.medReviewId !== this.med_review_id || card.classification === 'DISCONTINUED') {
      return res;
    }

    const status = card.type_of_change_string ? card.type_of_change_string.split(',') : [];
    for (let x of status) {
      x = x.trim();
      if (
        ['NTS', 'FREQ', 'DOSE', 'HOA', 'RES', 'REC'].indexOf(x) > -1 ||
        (card.classification === 'NEW' && x === 'NTS')
      )
        res += this.medReviewService.getIndicators([x]);
    }
    return res;
  }

  checkUncheckCard() {
    this.isSingleClick = true;
    setTimeout(() => {
      if (this.isSingleClick) {
        if (this.isPv && this.markErrorFn && !this.medicationError) {
          // const _title = 'Verify Prescription';
          // const _description = 'Are you sure to Verify Prescription?';
          // const _waitDesciption = '';
          // const dialogRef = this.layoutUtilsService.generalDialog(_title,
          // _description, 'Confirm', 'Cancel', true, true, _waitDesciption);
          // dialogRef.afterClosed().subscribe(res => {
          //   if (!res) {
          //     return;
          //   }
          this.medicationVerified = !this.medicationVerified;
          // this.medReviewService.verifyMedicationOnLocalNetwork(this.card.prescription.office_id, this.card.rxno).subscribe();
          if (this.verifyMedication)
            this.verifyMedication(this.card, this.medicationVerified ? '1' : '0');
          // })
        }
      }
    }, 250);
  }

  markError() {
    this.isSingleClick = false;
    if (this.isPv && !this.medicationVerified && !this.medicationError && this.markErrorFn) {
      const dialogRef = this.dialog.open(SelectErrorDialogComponent, {
        data: this.card,
        width: '300px',
      });
      dialogRef.afterClosed().subscribe((res) => {
        if (res && res.value && res.note) {
          this.medicationError = !this.medicationError;
          this.markErrorFn(this.card, res.value, res.note);
        }
      });
    }
  }

  getType(medication: any) {
    switch (medication.type) {
      case 'O':
      case 'o':
        return 'Other';
      // case 'E':
      // case 'e':
      //   return 'Electronic';
      case 'P':
      case 'p':
        return 'PRN';
      case 'C':
      case 'c':
        return 'Maintenance';
    }
    return medication.type;
  }

  showHistory(card) {
    this.dialog.open(MedicationHistoryComponent, {
      data: { medication: card },
      width: '700px',
    });
  }
  async showPrescriptionNotes(card: any) {
    try {
      this.dialog.open(PrescriptionNoteComponent, {
        width: 'auto',
        data: {
          card,
          currentUser: this.currentUser,
          viewPrescriptionNote: true,
          cardHasNotes: card.prescription?.has_notes,
        },
      });
    } catch (error) {
      // TODO: Handle error gracefully
    }
  }

  mouseOut() {
    this.isMouseHoverRx.next(false);
    this.cdr.detectChanges();
  }

  mouseEnter() {
    this.isMouseHoverRx.next(true);
  }

  formatDate(date) {
    if (date && moment.isDate(new Date(date))) {
      return moment(date).format('MM-DD-YYYY');
    }

    return '';
  }

  customDRP() {
    this.patientsService.getPatientByIds([this.patient_id]).subscribe((resPatients) => {
      const dialogRef = this.dialog.open(CustomDrpComponent, {
        data: {
          patient: resPatients.data[0],
          card: this.card,
          facility_cycle_date: resPatients.data[0].facility_cycle_date,
          from: 'MEDREVIEW',
        },
        width: '85vw',
        maxWidth: '85vw',
        height: '95vh',
      });
      dialogRef.afterClosed().subscribe(() => {
        this.medReviewService.emitDRP();
      });
    });
  }
}
